import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import RareBoxLogo from "../Logos/RareBoxLogo";
import { GlobalState } from "./GlobalContext";
import { CustomLinearProgress } from "components/ReusableComponents/CustomLinearProgress/CustomLinearProgress";
import { Outlet } from "react-router-dom";
import { AuthState } from "./AuthContext";
import { createSessionData } from "components/Reports/Reports";

const PosRecoContext = createContext();

const PosRecoProvider = ({ children }) => {
	const [filter, setFilter] = useState();
	const [loading, setLoading] = useState(false);
	const [reportLoading, setReportLoading] = useState(false);
	const [saleImDropdowns, setSaleImDropdowns] = useState();
	const { rootPath, setRootPath, setLoginUser, setLoadingOpen } = GlobalState();
	const [socket, setSocket] = useState(null);
	const [comments, setComments] = useState([]);
	const [allUsers, setAllUsers] = useState([]);
	const [notifyCount, setNotifyCount] = useState(0);
	const [sessionData, setSessionData] = useState([]);
	const [service, setService] = useState([]);
	const { user } = AuthState();

	return (
		<PosRecoContext.Provider
			value={{
				filter,
				setFilter,
				loading,
				setLoading,
				reportLoading,
				setReportLoading,
				saleImDropdowns,
				setSaleImDropdowns,
				socket,
				setSocket,
				comments,
				setComments,
				allUsers,
				setAllUsers,
				notifyCount,
				setNotifyCount,
				sessionData,
				setSessionData,
				service,
				setService,
			}}>
			{loading ? (
				<div
					style={{
						width: "200px",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%,-50%)",
					}}>
					<RareBoxLogo />
					<CustomLinearProgress />
				</div>
			) : (
				<Outlet />
			)}
		</PosRecoContext.Provider>
	);
};

export const PosRecoState = () => {
	return useContext(PosRecoContext);
};

export default PosRecoProvider;
